import { Routes, Route } from 'react-router-dom';
import Home from './pages/Home';
import Gallery from './pages/Gallery';
import About from './pages/About';
import ModelPage from './pages/ModelPage';
import Contact from './pages/Contact';
import TopBar from './components/General/TopBar';
import Footer from './components/General/Footer';

function App() {
  return (
    <div className="flex flex-col min-h-screen bg-gray-800 bg-opacity-80">
      <TopBar />
      <main className="flex-grow">
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/gallery" element={<Gallery />} />
          <Route path="/about" element={<About />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/model/:slug" element={<ModelPage />} />
        </Routes>
      </main>
      <Footer />
    </div>
  );
}

export default App;